import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
	0% { opacity: 0; }
	70% { opacity: 0; }
	100% { opacity: 1; }
`

export const Overlay = styled.div`
	pointer-events: auto;
	animation: ${fadeIn} 1s linear;
	display: flex;
	justify-content: space-around;
	align-items: center;
	height: 100%;
	width: 100%;
`
